/**
 * PromptFormEmptyState - Shown when no question type is selected in AI prompt form
 */

import * as React from 'react';
import { cn } from '@ai-content-hub/content-kit';
import { Sparkles } from 'lucide-react';

export interface PromptFormEmptyStateProps {
    className?: string;
    /** Optional custom title */
    title?: string;
    /** Optional custom description */
    description?: string;
}

const DEFAULT_TITLE = 'Select a question type to start';
const DEFAULT_DESCRIPTION = 'Choose a question type above to begin AI generation';

export const PromptFormEmptyState: React.FC<PromptFormEmptyStateProps> = ({
    className,
    title = DEFAULT_TITLE,
    description = DEFAULT_DESCRIPTION,
}) => (
    <div
        className={cn(
            'prompt-form-empty-state grid place-items-center w-full',
            'min-h-[calc(100vh-180px)] bg-muted/30 rounded-xl py-8',
            className
        )}
    >
        <div className="flex flex-col items-center py-14 px-8">
            <div
                className={cn(
                    'w-[88px] h-[88px] rounded-full flex items-center justify-center',
                    'bg-primary/10 text-primary mb-6'
                )}
            >
                <Sparkles className="h-9 w-9" />
            </div>
            <p className="text-base font-semibold text-foreground mb-2 text-center">
                {title}
            </p>
            <p className="text-sm text-muted-foreground text-center max-w-[380px] leading-relaxed">
                {description}
            </p>
        </div>
    </div>
);

PromptFormEmptyState.displayName = 'PromptFormEmptyState';
